export interface GetOneDto {
  include?: string;
  tenantId?: string;
}
